import { render, staticRenderFns } from "./DriverPunishOrders.vue?vue&type=template&id=21d45a9f&scoped=true"
import script from "./DriverPunishOrders.vue?vue&type=script&lang=js"
export * from "./DriverPunishOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d45a9f",
  null
  
)

export default component.exports